import { CirclePlay } from 'lucide-react';

import type { PostListItem } from '@/entities/post/types';
import { Skeleton } from '@/shared/components/shadcn/skeleton';

export const ExamplePostItem = ({
  post,
  onClick,
}: {
  post: PostListItem;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}) => {
  return (
    <a
      className="bg-muted flex w-full cursor-pointer flex-col gap-2 rounded-lg p-2 transition-all duration-200 hover:brightness-95"
      onClick={onClick}
    >
      <img
        src={post?.extraction.video?.poster_url}
        alt={post?._id}
        className="w-max-20 aspect-square w-full rounded-lg object-cover"
      />
      <span className="text-xs font-medium break-all text-gray-700">@{post?.author.username}</span>
      <span className="line-clamp-3 text-xs break-all text-gray-800">
        {post?.extraction.content}
      </span>
      <div className="flex items-center gap-1">
        <CirclePlay className="size-3 text-gray-600" />
        <span className="text-xs text-gray-600">{post?.extraction.engagement.view}</span>
      </div>
    </a>
  );
};

export const ExamplePostItemSkeleton = () => {
  return (
    <div className="bg-muted flex w-full flex-col gap-2 rounded-md p-2">
      <Skeleton className="aspect-square w-full rounded-lg bg-neutral-200" />
      <Skeleton className="h-2 w-full rounded-md bg-neutral-200" />
      <div className="flex flex-col items-start gap-1">
        <Skeleton className="h-3 w-4/5 rounded-md bg-neutral-200" />
        <Skeleton className="h-3 w-2/3 rounded-md bg-neutral-200" />
        <Skeleton className="h-3 w-3/4 rounded-md bg-neutral-200" />
      </div>
      <Skeleton className="h-2 w-2/5 rounded-md bg-neutral-200" />
    </div>
  );
};
